import "./global"

import "@modules/_vendor/css/bootstrap-pc.css"
// lds-grid10 needs to be imported after bootstrap-css, otherwise styles will break (bootstrap styles will overwrite lds-grid10 styles)
import "@modules/global/lds-grid10.css"
import "@modules/location/location-selector.css"
// TODO could be in global.ts but import order matters. There is a style in global-styles.pc which makes the close x
// in ad-free modal white instead of dark. Fix at some point? cannot move as effects are unclear.
import "@modules/global/icon-styles.css"
import "@modules/global/global-styles-pc.css"
import "@modules/global/header-pc.css"
import "@modules/header/login-notice-pc.css"

import "@modules/banner/header-banner-pc"
import "@modules/banner/banner-pc.css"
import "@modules/banner/donnerstag/header-donnerstag-pc.css"
import "@modules/banner/mittwoch/header-mittwoch-pc.css"
import "@modules/banner/sticky-banner/sticky-banner.ts"
import "@modules/banner/sticky-banner/sticky-banner-pc-base.css"
import "@modules/banner/easterfun/easterfun-pc.css"
import "@modules/banner/emfun/emfun-pc.css"
import "@modules/banner/xmasfun/xmasfun-pc.css"
import "@modules/banner/tasteTheStar/tastethestar-pc.css"
import "@modules/banner/football-championship/football-championship-shirt-pc.css"
// import "@modules/banner/muenchen/muenchen-messe-pc.css"
import "@modules/banner/muenchen/muenchen-auto-messe-pc.css"
// import "@modules/banner/muenchen/muenchen-valentines-pc.css"
// import "@modules/banner/muenchen/muenchen-wiesn-pc.css"
import "@modules/banner/city-highlight/city-highlight.ts"
import "@modules/banner/city-highlight/header-city-highlight-pc.css"

//feedback form and other forms

import("@modules/form/forms")

import "@modules/form/feedback/feedback-form-pc.css"
